module.exports = __webpack_public_path__ + "img/body-3-lg.4c3ab9f6.png";